
import axios from '../../config/axiosConfig';
import { 
    CREATE_PIPE_RETURN, 
    GET_PIPE_RETURNS, 
    PIPE_RETURN_REQUEST, 
    DELETE_PIPE_RETURN, 
    UPDATE_PIPE_RETURN, 
    PIPE_RETURN_REQUEST_FAILURE, 
    GET_PIPE_RETURNS_PAGE, 
    PIPE_RETURN_REQUEST_SUCCESS 
} from '../types';

export const getValidatedIncrementedVchNoPipeReturn = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/pipe-return/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPipeReturnWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Item,Account,Vehicle,PipeType'
      };
      return axios.get("/pipe-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PIPE_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPipeReturns = (include) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_RETURN_REQUEST });
            const { auth } = getState();
            let params = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth?.user?.Customer_Id
            };
            if (include) {
                params = { ...params, include };
            }
            return axios.get('/pipe-return/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_PIPE_RETURNS, payload: response.data?.data || [] });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getPipeReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_RETURN_REQUEST });
    
      return axios.get(`/pipe-return/get/${id}`).then((response) => {
        dispatch({ type: PIPE_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getPartyPipeBalanceInPipeReturn = (accountId) => {
  return async (dispatch, getState) => {
    try {
       const { auth } = getState();
       let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
       };
       if (accountId) {
        params = { ...params, accountId };
       }
    
      return axios.get(`/pipe-return/get-party-pipe-balance`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error);
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const createPipeReturn = (pipeReturn) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_RETURN_REQUEST });
            axios.post('/pipe-return/add', pipeReturn,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_PIPE_RETURN, payload: response.data });
                    } else {
                        dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: 'Pipe Return create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updatePipeReturn = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_RETURN_REQUEST });
            return axios.put('/pipe-return/update', { id, data }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_PIPE_RETURN, payload: { id, data: response.data } }, { params: { userId: auth.user?.id }});
                } else {
                    dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: 'Pipe Return update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deletePipeReturn = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_RETURN_REQUEST });
            axios.delete(`/pipe-return/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_PIPE_RETURN, id: id });
                    const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Return_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const searchCols = ['Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Return_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const { inventory: { pipeReturn: { page, pageSize, search, where } = {} } } = getState();
                    dispatch(getPipeReturnWithPagination(page, pageSize, include, search, searchCols, where, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_RETURN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};